export const anomalyColumnsCompact = [
  {label: "Anomaly Ref.", key: "anomaly_ref"},
  {label: "Site Name", key: "site_id"},
  {label: "Asset Name", key: "asset_id"},
  {label: "Component", key: "rds_component"},
  {label: "Description", key: "rds_description"},
  {label: "Subsystem", key: "rds_subsystem"},
  {label: "Inspection Technique", key: "inspection_technique"},
  {label: "Date Raised", key: "raised_at"},
  {label: "Failure Mode", key: "failure_mode"},
  {label: "Severity", key: "anomaly_severity"},
  {label: "Task ID", key: "task_id"},
  {label: "Open?", key: "open_closed"},
];

export const anomalyColumnsFull = [
  {label: "Anomaly Ref.", key: "anomaly_ref"},
  {label: "Site Name", key: "site_id"},
  {label: "Asset Name", key: "asset_id"},
  {label: "Task ID", key: "task_id"},
  {label: "Date Raised", key: "raised_at"},
  {label: "Failure Mode", key: "failure_mode"},
  {label: "Severity", key: "anomaly_severity"},
  {label: "Status", key: "anomaly_status"},
  {label: "Comments", key: "anomaly_comments"},
  {label: "Inspection Technique", key: "inspection_technique"},
  {label: "Inspected By", key: "inspected_by"},
  {label: "Component", key: "rds_component"},
  {label: "Description", key: "rds_description"},
  {label: "Subsystem", key: "rds_subsystem"},
  {label: "Report ID", key: "anomaly_report_id"},
  {label: "Preceded By", key: "preceded_by"},
  {label: "Succeeded By", key: "succeeded_by"},
  {label: "Date Raised", key: "raised_at"},
  {label: "Open?", key: "open_closed"},
];

export const anomalyFilters = [
  "site_id", "asset_id", "inspection_technique", "failure_mode", "anomaly_severity"
];